/**
 * Convert allowlisted report values to Custom Report form state.
 *
 * Choice labels come from the catalogue (`*_frontend_value`). The form
 * maps those onto Canvas options it already loaded - nothing here repeats
 * the type or interval tables.
 *
 * @param {object} values canonical agent values
 * @return {object} form patch
 */
export function mapReportsPrefill(values = {}) {
	const patch = {};
	if (typeof values.report_name === 'string' && values.report_name.trim()) {
		patch.report_name = values.report_name.trim();
	}
	const type = values.report_type_frontend_value || values.report_type;
	if (typeof type === 'string' && type.trim()) {
		patch.report_type = type.trim();
	}
	const interval = values.reporting_interval_frontend_value
		?? values.reporting_interval;
	if (interval != null && String(interval).trim() !== '') {
		patch.reporting_interval = String(interval).trim();
	}
	return patch;
}
